// extracted by mini-css-extract-plugin
module.exports = {"videoDetailContainer":"FullPlayer_videoDetailContainer__3EssB","noVideoContainer":"FullPlayer_noVideoContainer__19mOs","videoDetail":"FullPlayer_videoDetail__1eZBz"};